import { ChangeDetectionStrategy, Component, EventEmitter, Inject, OnDestroy, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CalendarService, ICalendarYear } from '@shared/services/calendar.service';
import { Subject } from 'rxjs';

const emptyGuid = '00000000-0000-0000-0000-000000000000';

@Component({
	selector: 'app-create-holidays',
	templateUrl: 'create-holidays.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CreateHolidaysComponent implements OnDestroy {
	@Output() created: EventEmitter<any> = new EventEmitter();
	httpError: string = '';

	years = [];
	defaultYear = 0;
	selectedYear = this.defaultYear;
	calendars;
	workTasks;
	selectedCalendar;
	selectedWorkTask;

	private destroyNotifier$ = new Subject<void>();

	constructor(
		public dialogRef: MatDialogRef<CreateHolidaysComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public calendarService: CalendarService,
		private translator: TranslateService,
		public dialog: MatDialog,
	) {}

	ngOnInit(): void {
		this.workTasks = this.data.workTasks.filter((workTask) => workTask.isActive && workTask.id && workTask.id !== emptyGuid).sort((a, b) => a.alias.toLowerCase().localeCompare(b.alias.toLowerCase()));

		// Set the default year to the next year
		this.defaultYear = new Date().getFullYear() + 1;
		this.selectedYear = this.defaultYear;

		// Populate years from two years before the current year to ten years after
		for (let year = this.defaultYear - 3; year <= this.defaultYear + 9; year++) {
			this.years.push(year);
		}

		// Load holiday calendars and select default country
		this.calendarService.getHolidayCalendars().subscribe((c) => {
			this.calendars = c;
			this.selectedCalendar = c.find((i) => i.countryCode === 'DK').countryCode;
		});
	}

	ngOnDestroy(): void {
		this.destroyNotifier$.next();
		this.destroyNotifier$.complete();
	}

	onCancel = () => this.dialogRef.close();

	async onSave() {
		const calendarYear: ICalendarYear = {
			year: this.selectedYear,
			holidayCalendar: this.selectedCalendar,
			workTaskId: this.selectedWorkTask,
			calendarId: this.data.calendarId,
		};

		this.calendarService.createHolidays(calendarYear).subscribe({
			next: () => {
				this.created.emit();
				this.dialogRef.close();
			},
			error: (errorResponse) => {
				this.httpError = `${errorResponse.status}`;
			},
		});
	}
}
